import type {TrackingEvent} from 'web-app/util/famlytics/types';

export const PlaygroundEvents = {
    IMPROVED_FUNDING_ROUNDING_OPT_OUT_IN: {
        name: 'Playground: Improved funding rounding opt out in',
        sendTo: ['Mixpanel'],
        isActive: true,
        expirationDate: 'none',
    },
} satisfies Record<string, TrackingEvent>;
